import Appbar from './Appbar'
import MobileAppbar from './MobileAppbar'

const isMobile = window.innerWidth < 1081

const bar = isMobile ? MobileAppbar : Appbar

export default bar
